import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.scss";

import Logo from "../../../assets/logo.png";
import { Header, Title, Subtitle, Text } from "../../../Components/Typography";
import { Button } from "../../../Components/Button";
import { Input } from "../../../Components/Input";
import useResponsive from "../../../hooks/useResponsive";
import { routes } from "../../../Router";
import {
  OrderContext,
  OrderContextProps,
} from "../../../Contexts/OrderContext";
import {
  FileUploadContext,
  FileUploadContextProps,
} from "../../../Contexts/FileUploadContext";
import {
  AddressContext,
  AddressContextProps,
} from "../../../Contexts/AddressContext";
import {
  PaymentContext,
  PaymentContextProps,
} from "../../../Contexts/PaymentContext";
import useDatabase from "../../../hooks/useDatabase";
import { toast } from "react-toastify";

export const Login = () => {
  const navigate = useNavigate();
  const { isDesktopOrLaptop } = useResponsive();
  const { getCollectionByTrackingCode } = useDatabase();
  const [trackingCode, setTrackingCode] = useState("");
  const [loading, setLoading] = useState(false);

  const { orderContextClear }: OrderContextProps =
    useContext<any>(OrderContext);

  const { fileUploadContextClear }: FileUploadContextProps =
    useContext<any>(FileUploadContext);

  const { addressContextClear }: AddressContextProps =
    useContext<any>(AddressContext);

  const { paymentContextClear }: PaymentContextProps =
    useContext<any>(PaymentContext);

  const clearAllForms = () => {
    orderContextClear();
    fileUploadContextClear();
    addressContextClear();
    paymentContextClear();
  };

  useEffect(() => {
    document.title = "El Rayo";
    clearAllForms();
  }, []);

  const onClickStart = () => {
    navigate(routes.clientNewOrder.path);
  };

  const onClickInstructions = () => {
    navigate(routes.clientInstructions.path);
  };

  const onClickViewOrder = async () => {
    setLoading(true);
    const orders = await getCollectionByTrackingCode(
      "view_order",
      trackingCode ?? ""
    );
    setLoading(false);

    if (orders && orders.length > 0) {
      navigate(
        routes.clientOrderStatus.path.replace(":trackingCode", trackingCode)
      );
    } else {
      toast.error(`Pedido no encontrado: ${trackingCode}`)
    }
  };

  return (
    <div className={isDesktopOrLaptop ? "login-desktop" : "login-mobile"}>
      <img className="logo" alt="logo" src={Logo} />

      <div className="column-form">
        <Header>Bienvenido</Header>

        <div className="title-section">
          <Title>Sistema de</Title>
          <Title>Impresiones Online</Title>
        </div>

        <div className="button-section">
          <Button onClick={onClickStart}>Comenzar</Button>
          <Button outlined onClick={onClickInstructions}>Instrucciones</Button>
        </div>

        <div className="order-section">
          <Subtitle>¿Ya realizaste un pedido?</Subtitle>
          <Input
            value={trackingCode}
            onChange={setTrackingCode}
            title="Ingresá el código de seguimiento"
          />
          <Button
            disabled={!trackingCode || loading}
            outlined
            onClick={onClickViewOrder}
          >
            {loading ? "Cargando" : "Ver mi pedido"}
          </Button>
        </div> 
      </div>
    </div>
  );
};
